import { createRoutine, bindRoutineToReduxForm, promisifyRoutine } from 'redux-saga-routines';

export const loginRoutine = createRoutine('LOGIN');
export const logoutRoutine = createRoutine('LOGOUT');
export const selectAccountRoutine = createRoutine('SELECT_ACCOUNT');
export const fetchAccountsRoutine = createRoutine('FETCH_ACCOUNTS');
export const fetchAccountRoutine = createRoutine('FETCH_ACCOUNT');

export const fetchProfileRoutine = createRoutine('FETCH_PROFILE');
export const fetchUserRoutine = fetchProfileRoutine;

export const fetchStaticRoutine = createRoutine('FETCH_STATIC');
export const fetchItemTypesRoutine = createRoutine('FETCH_ITEM_TYPES');

export const fetchTaskFileConfigsRoutine = createRoutine('FETCH_TASK_FILE_CONFIGS');

export const resetPasswordRoutine = createRoutine('RESET_PASSWORD');

export const registerRoutine = createRoutine('REGISTER');
export const registerFormHandler = bindRoutineToReduxForm(registerRoutine);

export const addAccountRoutine = createRoutine('ADD_ACCOUNT');
export const addAccountFormHandler = bindRoutineToReduxForm(addAccountRoutine);

export const fetchCustomersRoutine = createRoutine('FETCH_CUSTOMERS');
export const fetchCustomersPromise = promisifyRoutine(fetchCustomersRoutine);
export const fetchCustomerRoutine = createRoutine('FETCH_CUSTOMER');
export const saveCustomerRoutine = createRoutine('SAVE_CUSTOMER');
export const saveCustomerFormHandler = bindRoutineToReduxForm(saveCustomerRoutine);
export const removeCustomerRoutine = createRoutine('REMOVE_CUSTOMER');

export const saveCustomerAddressRoutine = createRoutine('SAVE_CUSTOMER_ADDRESS');
export const saveCustomerAddressPromise = promisifyRoutine(saveCustomerAddressRoutine);

export const saveCustomerLogoRoutine = createRoutine('SAVE_CUSTOMER_LOGO');
export const saveCustomerLogoPromise = promisifyRoutine(saveCustomerLogoRoutine);

export const fetchJobsRoutine = createRoutine('FETCH_JOBS');
export const fetchJobRoutine = createRoutine('FETCH_JOB');
export const saveJobRoutine = createRoutine('SAVE_JOB');
export const saveJobFormHandler = bindRoutineToReduxForm(saveJobRoutine);
export const removeJobRoutine = createRoutine('REMOVE_JOB');
export const removeJobPromise = promisifyRoutine(removeJobRoutine);

export const saveJobResourcesRoutine = createRoutine('SAVE_JOB_RESOURCES');

export const fetchExceptionsRoutine = createRoutine('FETCH_EXCEPTIONS');
export const resolveExceptionRoutine = createRoutine('RESOLVE_EXCEPTION');
export const resolveExceptionFormHandler = bindRoutineToReduxForm(resolveExceptionRoutine);

export const fetchTasksRoutine = createRoutine('FETCH_TASKS');
export const fetchTaskRoutine = createRoutine('FETCH_TASK');
export const uploadTasksRoutine = createRoutine('UPLOAD_TASKS');
export const removeTasksRoutine = createRoutine('REMOVE_TASKS');
export const saveTaskAssignmentsRoutine = createRoutine('SAVE_TASK_ASSIGNMENTS');

export const fetchRecentActivityRoutine = createRoutine('FETCH_RECENT_ACTIVITY');

export const fetchEmployeesRoutine = createRoutine('FETCH_EMPLOYEES');
export const fetchEmployeesPromise = promisifyRoutine(fetchEmployeesRoutine);
export const fetchEmployeeRoutine = createRoutine('FETCH_EMPLOYEE');
export const saveEmployeeRoutine = createRoutine('SAVE_EMPLOYEE');
export const saveEmployeeFormHandler = bindRoutineToReduxForm(saveEmployeeRoutine);
export const removeEmployeeRoutine = createRoutine('REMOVE_EMPLOYEE');
export const removeEmployeePromise = promisifyRoutine(removeEmployeeRoutine);

export const fetchLabelFormatsRoutine = createRoutine('FETCH_LABEL_FORMATS');
export const editTaskRoutine = createRoutine('EDIT_TASK');

export const fetchRolesRoutine = createRoutine('FETCH_ROLES');
export const saveRoleRoutine = createRoutine('SAVE_ROLE');
export const saveRoleFormHandler = bindRoutineToReduxForm(saveRoleRoutine);
export const removeRoleRoutine = createRoutine('REMOVE_ROLE');
export const removeRolePromise = promisifyRoutine(removeRoleRoutine);

export const fetchJobProfilesRoutine = createRoutine('FETCH_JOB_PROFILES');
export const fetchJobProfileRoutine = createRoutine('FETCH_JOB_PROFILE');
export const saveJobProfileRoutine = createRoutine('SAVE_JOB_PROFILE');
export const saveJobProfileFormHandler = bindRoutineToReduxForm(saveJobProfileRoutine);
export const removeJobProfileRoutine = createRoutine('REMOVE_JOB_PROFILE');
export const removeJobProfilePromise = promisifyRoutine(removeJobProfileRoutine);

export const fetchTaskProfilesRoutine = createRoutine('FETCH_TASK_PROFILES');
export const fetchTaskProfileRoutine = createRoutine('FETCH_TASK_PROFILE');
export const saveTaskProfileRoutine = createRoutine('SAVE_TASK_PROFILE');
export const saveTaskProfileFormHandler = bindRoutineToReduxForm(saveTaskProfileRoutine);
export const removeTaskProfileRoutine = createRoutine('REMOVE_TASK_PROFILE');
export const removeTaskProfilePromise = promisifyRoutine(removeTaskProfileRoutine);

export const fetchSettingsRoutine = createRoutine('FETCH_SETTINGS');
export const upgradeAccountRoutine = createRoutine('UPGRADE_ACCOUNT');
export const upgradeAccountPromise = promisifyRoutine(upgradeAccountRoutine);
export const fetchTaskCountRoutine = createRoutine('FETCH_TASK_COUNT');
export const fetchPaymentSourceRoutine = createRoutine('FETCH_PAYMENT_SOURCE');
export const updatePaymentSourceRoutine = createRoutine('UPDATE_PAYMENT_SOURCE');
export const updatePaymentSourcePromise = promisifyRoutine(updatePaymentSourceRoutine);
export const fetchInvoicesRoutine = createRoutine('FETCH_INVOICES');

export const cancelAccountRoutine = createRoutine('CANCEL_ACCOUNT');

export const fetchPrintersRoutine = createRoutine('FETCH_PRINTERS');
export const savePrinterRoutine = createRoutine('SAVE_PRINTER');
export const savePrinterFormHandler = bindRoutineToReduxForm(savePrinterRoutine);
export const removePrinterRoutine = createRoutine('REMOVE_PRINTER');
export const removePrinterPromise = promisifyRoutine(removePrinterRoutine);

export const fetchReportRoutine = createRoutine('FETCH_REPORT');

export const sendTaskEmailRoutine = createRoutine('SEND_TASK_EMAIL');
export const sendTaskEmailFormHandler = bindRoutineToReduxForm(sendTaskEmailRoutine);
export const sendTaskSmsRoutine = createRoutine('SEND_TASK_SMS');
export const sendTaskSmsFormHandler = bindRoutineToReduxForm(sendTaskSmsRoutine);



// WEBPACK FOOTER //
// ./src/redux/routines.js